import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { StockOutResponseDto } from '.';

export class getAllStockInDetailsResponseModel extends GlobalResponseObject {
    data?: StockOutResponseDto[];

    /**
     * 
     * @param status 
     * @param errorCode 
     * @param internalMessage 
     * @param data 
     */
    constructor(status:boolean, errorCode:number, internalMessage:string, data?: StockOutResponseDto[]){
        super(status,errorCode,internalMessage);
        this.data = data;
    }
}